/**
 * Route paths for the dashboard module.
 * Single source of truth — reuse these instead of hard-coding `/dashboard` strings.
 */
export const DASHBOARD_ROUTES = {
  root: "/dashboard",
} as const;
